<template>
    <div id="stepTwoForm" class="step-form">
        <form>
            <p>
                Please provide information about the production you'd like to
                film in Mississauga.
            </p>
            <div class="form-row">
                <TextInput
                    inputId="ProductionTitle"
                    labelText="Production title"
                    v-model="ProductionTitle"
                    :validation="[
                        {
                            type: 'max',
                            value: 50,
                            msg: `The title can't be longer than 50 characters.`,
                        },
                    ]"
                    helpText="Max of 50 characters."
                    :wrapperClasses="['col-md-8']"
                />
            </div>
            <div class="form-row">
                <SelectInput
                    inputId="ProductionType"
                    labelText="Production type"
                    v-model="ProductionType"
                    :wrapperClasses="['col-md-4']"
                    :options="typeSelect"
                />
                <TextInput
                    inputId="ProductionType_EpisodeNumber"
                    labelText="Episode number"
                    v-model="ProductionType_EpisodeNumber"
                    :isRequired="ProductionType == ('FILM07' || 'FILM03')"
                    :disabled="ProductionType != ('FILM07' || 'FILM03')"
                    :class="
                        ProductionType != ('FILM07' || 'FILM03')
                            ? 'd-none'
                            : null
                    "
                    :validate="[
                        {
                            type: 'max',
                            value: 12,
                            msg: 'This must be less than 12 characters',
                        },
                    ]"
                />
            </div>
            <div class="form-row">
                <TextAreaInput
                    inputId="ProductionType_Other"
                    labelText="Please describe the production type"
                    v-model="ProductionType_Other"
                    :isRequired="ProductionType == 'FILM10'"
                    :disabled="ProductionType != 'FILM10'"
                    :class="ProductionType != 'FILM10' ? 'd-none' : null"
                    :wrapperClasses="['col-md-8']"
                />
            </div>
            <div class="form-row" v-if="formType === 'grid'"> <!--for grid application-->
                <NumberInput
                    inputId="NumOfVehicles"
                    labelText= "Number of production vehicles associated with GRID permit"    
                    v-model="NumOfVehicles"
                    :validation="[
                        {
                            type: 'max',
                            value: 99,
                            msg: `You can't have more than 99 vehicles`,
                        },
                    ]"
                />
            </div>
            <div class="form-row" v-else> <!--regular permit application-->
                <NumberInput
                    inputId="NumOfVehicles"
                    labelText= "Number of production vehicles on-location"    
                    v-model="NumOfVehicles"
                    :validation="[
                        {
                            type: 'max',
                            value: 99,
                            msg: `You can't have more than 99 vehicles`,
                        },
                    ]"
                />
            </div>
            <div class="form-row">
                <NumberInput
                    inputId="NumOfCastCrew"
                    labelText="Number of cast and crew on-location"
                    v-model="NumOfCastCrew"
                    :validation="[
                        {
                            type: 'max',
                            value: 999999999,
                            msg: `Number of cast and crew can't be more than 999,999,999`,
                        },
                    ]"
                />
            </div>
            <label class="form-label"
                >We will include the City of Mississauga in our credits:</label
            >
            <div class="form-row mb-3">
                <RadioInput
                    inputId="Consent_CityCredit"
                    v-model="Consent_CityCredit"
                    name="Consent_CityCredit"
                    :options="[
                        { text: 'Yes', value: 'Y' },
                        { text: 'No', value: 'N' },
                    ]"
                    :inline="true"
                />
            </div>
            <p class="form-subheading" v-if="formType === 'grid'">Filming Dates (please add applicable dates for this GRID application):</p>
            <p class="form-subheading" v-else>Filming Dates (please add applicable dates for this filming occurrence):</p>
            <label class="form-label">Film start date</label>
            <DateTimeInput
                inputId="Filming_StartDate"
                v-model="Filming_StartDate"
                :srOnly="true"
                :defaultTime="{ hour: 7, minute: 0 }"
            />

            <label class="form-label">Film end date</label>
            <DateTimeInput
                inputId="Filming_EndDate"
                v-model="Filming_EndDate"
                :srOnly="true"
                :defaultTime="{ hour: 23, minute: 0 }"
                :startDate="Filming_StartDate"
                :validation="[
                    {
                        type: 'before',
                        value: Filming_StartDate,
                        msg: 'Your end date can\'t be before your start date.',
                    },
                ]"
            />

            <div class="form-row md-3">
                <div class="md-1">
                    <CheckboxInput
                        inputId="prepDate"
                        labelText="Add a prep date"
                        v-model="prepDate"
                        :inline="true"
                        :isRequired="false"
                        v-show="$attrs.formType == 'permit'"
                    />
                    <CheckboxInput
                        inputId="wrapDate"
                        labelText="Add a wrap date"
                        v-model="wrapDate"
                        :inline="true"
                        :isRequired="false"
                        v-show="$attrs.formType == 'permit'"
                    />

                    <CheckboxInput style="display:inline-block;padding-right:0px;border:solid red 0px;"
                        inputId="weatherDate"
                        labelText="Add a weather date"
                        v-model="weatherDate"
                        :inline="true"
                        :isRequired="false"
                        v-show="$attrs.formType == 'permit'"
                    />
                    <div v-show="$attrs.formType == 'permit'" style="display: inline-block;width: 40px;margin-left:0px;"><i class="far fa-question-circle" v-b-popover.hover.right="{ variant: 'info',  content: 'Weather date applies to 1 business day post-filming date' }" ></i></div>

                </div>
            </div>

            

            <fieldset v-show="prepDate">
                <label class="form-label">Prep start date</label>
                <DateTimeInput
                    inputId="Prep_StartDate"
                    v-model="Prep_StartDate"
                    :isRequired="prepDate"
                    :srOnly="true"
                    :defaultTime="{ hour: 7, minute: 0 }"
                />
            </fieldset>

            <fieldset v-show="prepDate">
                <label class="form-label">Prep end date</label>
                <DateTimeInput
                    inputId="Prep_EndDate"
                    v-model="Prep_EndDate"
                    :isRequired="prepDate"
                    :srOnly="true"
                    :defaultTime="{ hour: 23, minute: 0 }"
                    :startDate="Prep_StartDate"
                    :validation="[
                        {
                            type: 'before',
                            value: Prep_StartDate,
                            msg:
                                'Your end date can\'t be before your start date.',
                        },
                    ]"
                />
            </fieldset>

            <fieldset v-show="wrapDate">
                <label class="form-label">Wrap start date</label>
                <DateTimeInput
                    inputId="Wrap_StartDate"
                    v-model="Wrap_StartDate"
                    :isRequired="wrapDate"
                    :srOnly="true"
                    :defaultTime="{ hour: 7, minute: 0 }"
                    :validation="[
                        {
                            type: 'before',
                            value: Filming_StartDate,
                            msg:
                                'Your wrap date can\'t be before your filming start date.',
                        },
                    ]"
                />
            </fieldset>

            <fieldset v-show="wrapDate">
                <label class="form-label">Wrap end date</label>
                <DateTimeInput
                    inputId="Wrap_EndDate"
                    v-model="Wrap_EndDate"
                    :isRequired="wrapDate"
                    :srOnly="true"
                    :startDate="Wrap_StartDate"
                    :validation="[
                        {
                            type: 'before',
                            value: Wrap_StartDate,
                            msg:
                                'Your end date can\'t be before your start date.',
                        },
                    ]"
                    :defaultTime="{ hour: 23, minute: 0 }"
                />
            </fieldset>

            <fieldset v-show="weatherDate">
                <label class="form-label">Weather date</label>
                <DateTimeInput
                    inputId="Weather_Date"
                    v-model="Weather_Date"
                    :isRequired="weatherDate"
                    :srOnly="true"
                    :defaultTime="{ hour: 7, minute: 0 }"
                />
            </fieldset>
        </form>
        <div class="alert alert-danger mt-3" v-if="_errorsExist && submitted">
            Please make sure you've filled all the fields out correctly.
        </div>
        <div class="d-flex justify-content-begin">
            <button
                id="previousStep"
                class="mt-3 mr-3 btn btn-secondary"
                @click="previousStep"
            >
                Previous
            </button>

            <button
                id="nextStep"
                class="mt-3 btn btn-primary"
                @click="nextStep"
            >
                Next
            </button>
        </div>
    </div>
</template>

<script>
import TextInput from '@/components/inputs/TextInput.vue';
import RadioInput from '@/components/inputs/RadioInput.vue';
import CheckboxInput from '@/components/inputs/CheckboxInput.vue';
import SelectInput from '@/components/inputs/SelectInput.vue';
import NumberInput from '@/components/inputs/NumberInput.vue';
import TextAreaInput from '@/components/inputs/TextAreaInput.vue';
import DateTimeInput from '@/components/inputs/DateTimeInput.vue';


export default {
    name: 'StepTwoForm',
    components: {
        TextInput,
        TextAreaInput,
        RadioInput,
        CheckboxInput,
        DateTimeInput,
        NumberInput,
        SelectInput,
    },
    data() {
        return {
            step: 2,
            typeSelect: [
                { value: 'FILM01', text: 'Commercial' },
                { value: 'FILM02', text: 'Feature' },
                { value: 'FILM03', text: 'Mini Series' },
                { value: 'FILM04', text: 'Music Video' },
                { value: 'FILM05', text: 'Student' },
                { value: 'FILM06', text: 'TV Movie' },
                { value: 'FILM07', text: 'TV Series' },
                { value: 'FILM08', text: 'TV Special' },
                { value: 'FILM09', text: 'Web Series' },
                { value: 'FILM10', text: 'Other' },
            ],
            /*
            currencySelect: [
                { value: 'CAD', text: 'CAD' },
                { value: 'USD', text: 'USD' },
            ],
            */
            submitted: false,
        };
    },
    computed: {
        formType() {
            return this.$store.getters.formType;
        },
        ProductionType: {
            get() {
                return this.$store.state.formData.ProductionType;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'ProductionType',
                    data: value,
                });
            },
        },
        ProductionTitle: {
            get() {
                return this.$store.state.formData.ProductionTitle;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'ProductionTitle',
                    data: value,
                });
            },
        },
        ProductionType_EpisodeNumber: {
            get() {
                return this.$store.state.formData.ProductionType_EpisodeNumber;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'ProductionType_EpisodeNumber',
                    data: value,
                });
            },
        },
        ProductionType_Other: {
            get() {
                return this.$store.state.formData.ProductionType_Other;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'ProductionType_Other',
                    data: value,
                });
            },
        },
        Prep_StartDate: {
            get() {
                return this.$store.state.formData.Prep_StartDate;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'Prep_StartDate',
                    data: value,
                });
            },
        },
        Prep_EndDate: {
            get() {
                return this.$store.state.formData.Prep_EndDate;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'Prep_EndDate',
                    data: value,
                });
            },
        },
        Filming_StartDate: {
            get() {
                return this.$store.state.formData.Filming_StartDate;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'Filming_StartDate',
                    data: value,
                });
            },
        },
        Filming_EndDate: {
            get() {
                return this.$store.state.formData.Filming_EndDate;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'Filming_EndDate',
                    data: value,
                });
            },
        },
        Wrap_StartDate: {
            get() {
                return this.$store.state.formData.Wrap_StartDate;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'Wrap_StartDate',
                    data: value,
                });
            },
        },
        Wrap_EndDate: {
            get() {
                return this.$store.state.formData.Wrap_EndDate;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'Wrap_EndDate',
                    data: value,
                });
            },
        },
        Weather_Date: {
            get() {
                return this.$store.state.formData.Weather_Date;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'Weather_Date',
                    data: value,
                });
            },
        },
        NumOfVehicles: {
            get() {
                return this.$store.state.formData.NumOfVehicles;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'NumOfVehicles',
                    data: Number(value),
                });
            },
        },
        NumOfCastCrew: {
            get() {
                return this.$store.state.formData.NumOfCastCrew;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'NumOfCastCrew',
                    data: Number(value),
                });
            },
        },
        /*
        TOTALPRODBUDGET: {
            get() {
                return this.$store.state.formData.TOTALPRODBUDGET;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'TOTALPRODBUDGET',
                    data: Number(value),
                });
            },
        },
        TOTCADCB: {
            get() {
                if (this.$store.state.formData.TOTCADCB == 'Y') {
                    return 'CAD';
                } else {
                    return 'USD';
                }
            },
            set(value) {
                if (value == 'CAD') {
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'TOTCADCB',
                        data: 'Y',
                    });
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'TOTALUSDCB',
                        data: 'N',
                    });
                } else {
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'TOTCADCB',
                        data: 'N',
                    });
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'TOTALUSDCB',
                        data: 'Y',
                    });
                }
            },
        },
        ESTSPEND: {
            get() {
                return this.$store.state.formData.ESTSPEND;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'ESTSPEND',
                    data: Number(value),
                });
            },
        },
        ESTCADCB: {
            get() {
                if (this.$store.state.formData.ESTCADCB == 'Y') {
                    return 'CAD';
                } else {
                    return 'USD';
                }
            },
            set(value) {
                if (value == 'CAD') {
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'ESTCADCB',
                        data: 'Y',
                    });
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'ESTUSDCB',
                        data: 'N',
                    });
                } else {
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'ESTCADCB',
                        data: 'N',
                    });
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'ESTUSDCB',
                        data: 'Y',
                    });
                }
            },
        },
        */
        Consent_CityCredit: {
            get() {
                return this.$store.state.formData.Consent_CityCredit;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'Consent_CityCredit',
                    data: value,
                });
            },
        },
        weatherDate: {
            get() {
                return this.$store.state.weatherDate;
            },
            set(value) {
                this.$store.dispatch('TOGGLE_DATE', {
                    field: 'weatherDate',
                    data: value,
                });
                if(value==false) //if uncheck -> clear out input value for "Weather_Date" field
                {
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'Weather_Date',
                        data: '',
                    });
                }
            },
        },
        prepDate: {
            get() {
                return this.$store.state.prepDate;
            },
            set(value) {
                this.$store.dispatch('TOGGLE_DATE', {
                    field: 'prepDate',
                    data: value,
                });
                if(value==false) //if uncheck -> clear out input value for "Prep_Date" fields
                {
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'Prep_StartDate',
                        data: '',
                    });
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'Prep_EndDate',
                        data: '',
                    });
                }
            },
        },
        wrapDate: {
            get() {
                return this.$store.state.wrapDate;
            },
            set(value) {
                this.$store.dispatch('TOGGLE_DATE', {
                    field: 'wrapDate',
                    data: value,
                });
                if(value==false) //if uncheck -> clear out input value for "Wrap_Date" fields
                {
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'Wrap_StartDate',
                        data: '',
                    });
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'Wrap_EndDate',
                        data: '',
                    });
                }
            },
        },
    },
    methods: {
        nextStep() {
            this.submitted = true;

            if (!this._errorsExist()) {
                this.$store.dispatch('COMPLETE_STEP', {
                    step: this.step,
                    complete: true,
                });
                this.$emit('nextStep');
            }
        },
        previousStep() { 
                this.$store.dispatch('SET_STEP', this.step - 1);        
        }
    },
    mounted() {
        document.getElementById('stepTwoForm').focus();
    },
};
</script>
